import { RequestRemark } from "./Request";

export enum OutsideEnrollmentAreaStatus {
  /// <summary>
  /// Nije obrađeno<br/>
  /// Na postupku upisa naznačeno da roditelj/skrbnik želi dijete upisati u školu izvan upisnog područja
  /// </summary>
  NotProcessed = 1,
  /// <summary>
  /// Donesena odluka (rješenje)<br/>
  /// UO/GU donio odluku o osnovnoj školi u koju će dijete biti upisano ili rješenje o upisu na kojem je odabrana škola u koju će dijete biti upisano
  /// </summary>
  Decision = 3,
  /// <summary>
  /// Sugeriran upis - prihvaćeno<br/>
  /// Škola izvan upisnog područja je sugerirala ima li mjesta za školskog obveznika u njihovoj školi ili ne
  /// </summary>
  SuggestedEnrollmentAccepted = 4,
  /// <summary>
  /// Sugeriran upis - odbijeno<br/>
  /// Škola izvan upisnog područja je sugerirala ima li mjesta za školskog obveznika u njihovoj školi ili ne
  /// </summary>
  SuggestedEnrollmentRejected = 5,
}

export interface SetOutsideEnrollmentAreaStatusPayload {
  requestId: number;
  outsideEnrollmentAreaStatus: OutsideEnrollmentAreaStatus;
  isApproved: boolean;
  request?: Request;
  requestRemark: RequestRemark;
}
